import { render } from "./Spinner.vue?vue&type=template&id=7989a638&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=7989a638&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7989a638"]])

export default __exports__